/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function SearchOrAsk({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentcolor" d="M2.491 3.1a6.1 6.1 0 0 1 5.51-1.668l.385.09.114.042A.6.6 0 0 1 8.196 2.7l-.12-.02-.309-.07A4.9 4.9 0 1 0 11.3 9.365a.601.601 0 0 1 1.102.476c-.22.51-.516.995-.882 1.44l2.99 2.99.078.094a.6.6 0 0 1-.831.831l-.094-.077-2.99-2.99A6.1 6.1 0 0 1 2.49 3.1" /><path fill="currentcolor" fillRule="evenodd" d="M11.22 1.075a.725.725 0 0 1 1.263 0l.05.113c.173.493.28.79.396 1.018l.122.208q.181.27.426.489l.168.137c.187.14.404.249.773.406l.424.177a.734.734 0 0 1 0 1.356l-.424.177c-.369.157-.586.265-.773.405l-.168.137a2.6 2.6 0 0 0-.426.49l-.123.208c-.115.227-.222.524-.395 1.018l-.05.113c-.287.528-1.1.49-1.313-.113l-.155-.433c-.137-.377-.233-.599-.363-.793l-.128-.176a2.6 2.6 0 0 0-.467-.451l-.2-.133c-.221-.127-.512-.25-.996-.449l-.106-.054a.736.736 0 0 1 0-1.249l.106-.053c.484-.2.775-.322.995-.45l.201-.133q.264-.196.467-.452l.128-.174c.13-.195.226-.417.363-.793l.155-.433zm.631 1.657a3 3 0 0 1-.202.35l-.188.256q-.3.374-.683.662l-.152.108q-.157.103-.331.192.174.09.33.194l.153.107q.383.288.683.662l.188.257q.112.166.202.349.05-.099.104-.192l.098-.157q.268-.399.625-.718l.247-.201c.15-.113.31-.21.484-.3a3.5 3.5 0 0 1-.484-.3l-.247-.202a3.8 3.8 0 0 1-.625-.718l-.098-.157a4 4 0 0 1-.104-.192" clipRule="evenodd" /></svg>;
}
;